import React from 'react';
import { Layout, Button } from 'antd';
import { LogoutModal } from './components';
import { SidebarMenu } from './components';
import { MobileHeader } from './components';
import { SidebarFooter } from './components';
import { SidebarHeader } from './components';
import { MobileBackdrop } from './components';
import { useWarehouseAuth } from './hooks';
import { useSidebarCollapse } from './hooks';
import { useMobileResponsive } from './hooks';
import { MenuOutlined } from '@ant-design/icons';
import './styles.scss';

const { Sider } = Layout;

interface WarehouseSideBarProps {
  collapsed?: boolean;
  onCollapse?: (collapsed: boolean) => void;
}

export const WarehouseSideBar: React.FC<WarehouseSideBarProps> = ({ collapsed = false, onCollapse }) => {
  // Custom hooks for cleaner logic separation
  const { internalCollapsed, handleCollapse } = useSidebarCollapse({
    initialCollapsed: collapsed,
    onCollapse,
  });

  const { isMobile, mobileMenuOpen, handleMobileMenuToggle, handleMobileMenuClose } = useMobileResponsive();

  const { isLogoutModalOpen, handleLogoutClick, handleLogoutConfirm, handleLogoutCancel } = useWarehouseAuth();

  return (
    <>
      {/* Mobile Header */}
      {isMobile && <MobileHeader onMenuToggle={handleMobileMenuToggle} />}

      {/* Mobile Backdrop */}
      {isMobile && mobileMenuOpen && <MobileBackdrop onClose={handleMobileMenuClose} />}

      {/* Sidebar */}
      <Sider
        collapsible
        collapsed={isMobile ? false : internalCollapsed}
        onCollapse={handleCollapse}
        className={`warehouse-sidebar ${isMobile ? 'mobile-sidebar' : ''} ${isMobile && mobileMenuOpen ? 'mobile-open' : ''}`}
        theme="light"
        width={280}
        trigger={!isMobile ? <Button type="text" icon={<MenuOutlined />} className="collapse-trigger" /> : null}
      >
        <div className="warehouse-sidebar-content">
          {/* Header */}
          <SidebarHeader isMobile={isMobile} isCollapsed={internalCollapsed} onMobileClose={handleMobileMenuClose} />

          {/* Navigation Menu */}
          <SidebarMenu isMobile={isMobile} onMobileClose={handleMobileMenuClose} />

          {/* Logout Button */}
          <SidebarFooter isCollapsed={internalCollapsed} isMobile={isMobile} onLogoutClick={handleLogoutClick} />
        </div>
      </Sider>

      {/* Logout Confirmation Modal */}
      <LogoutModal isOpen={isLogoutModalOpen} onConfirm={handleLogoutConfirm} onCancel={handleLogoutCancel} />
    </>
  );
};
